import type {ReactElement} from 'react';


export enum VerticalVideoPreviewPlatform {
  FACEBOOK = 'FACEBOOK',
  YOUTUBE = 'YOUTUBE',
  TIKTOK = 'TIKTOK',
}

export interface VerticalVideoPlatformChrome {
  footer: ReactElement | null;
  mediaFrameClassName: string;
  overlay: ReactElement;
}
